import { render, staticRenderFns } from "./EditProfileWindow.vue?vue&type=template&id=42d0a450"
import script from "./EditProfileWindow.vue?vue&type=script&lang=js"
export * from "./EditProfileWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VForm,VIcon,VTextField,VToolbar,VToolbarTitle,VWindowItem})
